import { OPEN_MENU } from 'action-types';

export default function () {
  return {
    type: OPEN_MENU,
  };
}
